import persistState, { mergePersistedState } from 'redux-localstorage';
import adapterCreator from 'redux-localstorage/lib/adapters/localStorage';
import filter from 'redux-localstorage-filter';
import { migrateState } from 'acscp/store/helpers/stateMigration';

const baseStorage = adapterCreator(window.localStorage);

const filteredStorage = filter(
    [
        'auth.token', 'auth.username', 'auth.refreshToken', 'auth.sharingTokens', 'auth.loginPageVariant',
        'intl.locale', 'intl.languageState',
        'gifts.giftBasketQuantities'
    ]
)(baseStorage);

export const statePersistor = persistState(filteredStorage);

// By default mergePersistedState performs a shallow merge -> we need auth to be
// a deeper merge.
export const stateRehydrator =
    mergePersistedState((initialState: any, persistedState: any) => {
        const state = {
            ...initialState,
            ...persistedState,
            auth: {
                ...initialState.auth,
                ...persistedState.auth,
            },
            gifts: {
                ...initialState.gifts,
                ...persistedState.gifts,
            },
            intl: {
                ...initialState.intl,
                ...persistedState.intl,
            }
        };

        return migrateState(state);
    });
